import React, {useState} from "react";
import styled from "styled-components";
import {flexCreator} from "../../hooks/helpers";
import {Link, useHistory} from "react-router-dom";
import {ReactComponent as EmblemIcon} from "../../assets/icons/programa_emblem.svg";
import {ReactComponent as EnterpriseIcon} from "../../assets/icons/programa_enterprise.svg";
import {ReactComponent as EssentialIcon} from "../../assets/icons/cursos_esenciales.svg";
import {ReactComponent as PrimeIcon} from "../../assets/icons/certificado_prime.svg";
import {ReactComponent as PlusIcon} from "../../assets/icons/plus.svg";
import HeadView from "../../containers/HeadView";
import {ButtonWithIcon} from "../../styles/Butttons";
import ModalNew from "./components/ModalNew";

const ListCards = [
   {title: "cursos esenciales", icon: EssentialIcon, back: "#af0069", link: "/offer/cursos_esenciales", num: 1},
   {title: "certificado prime", icon: PrimeIcon, back: "#8e44ad", link: "/offer/certificado_prime", num: 2},
   {title: "programa emblem", icon: EmblemIcon, back: "#2980b9", link: "/offer/programa_emblem", num: 4},
   {title: "programa enterprise", icon: EnterpriseIcon, back: "#95afc0", link: "/offer/programa_enterprise"},
];

export default function OfferView() {
   const [newModal, setNewModal] = useState(false);
   let history = useHistory();

   const changeSelect = (val) => {
      console.log(val);
      history.push(val.link, {prev: val.prev || "/offer"});
   };
   return (
      <>
         <HeadView>
            <></>
            <>
               <ButtonWithIcon
                  text="Crear nuevo"
                  Icon={PlusIcon}
                  classname="text"
                  action={() => {
                     setNewModal(true);
                  }}
               />
            </>
         </HeadView>
         <ListOffer>
            {React.Children.toArray(
               ListCards.map((item) => (
                  <LinkItem to={item.link} back={item.back}>
                     <div>
                        <item.icon fill="white" heigth="3em" className="icon" />
                     </div>
                     <span>{item.title}</span>
                  </LinkItem>
               )),
            )}
         </ListOffer>
         <ModalNew
            isOpen={newModal}
            close={() => {
               setNewModal(false);
            }}
            change={changeSelect}
         />
      </>
   );
}

const ListOffer = styled.div`
   width: 100%;
   ${flexCreator("between", "center")};
   // margin-top: 2em;
`;

const LinkItem = styled(Link)`
   background: ${(props) => props.back};
   border-radius: 3px;
   padding: 2em 2em;
   box-sizing: border-box;
   text-align: center;
   text-decoration: none;
   color: white;
   font-weight: 300;
   text-transform: capitalize;

   > div {
      height: 3em;
      width: 3em;
      margin: 0 auto;
      text-align: center;

      & .icon {
         display: block;
      }
   }

   span {
      margin-top: 1.5em;
      font-size: 1em;
      display: block;
   }
`;
